module.exports = __webpack_public_path__ + "img/hamburger-menu.b8bcc69e.svg";